import { render, staticRenderFns } from "./contractorDetail.vue?vue&type=template&id=f48863e4&"
import script from "./contractorDetail.vue?vue&type=script&lang=js&"
export * from "./contractorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports